import { brandInitials } from "../lib/branding";
import { useBranding } from "../lib/brandingContext";
import { Mark } from "./Mark";

/**
 * Figma "29 Onboarding" (node 22482:45625).
 *
 * The frame is a centred logo on a blank canvas — a boot screen, not a wizard.
 * App shows it for the first paint, so a cold load lands on the brand instead
 * of an empty shell while the route resolves. On a workspace host (#85) the
 * brand is the org's.
 */
export function Splash() {
  const { branding } = useBranding();
  const name = branding?.displayName ?? null;
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-grey-25 font-sans"
      role="status"
      aria-label={name ? `Loading ${name}` : "Loading SemantiCAD"}
      data-testid="splash"
    >
      {name ? (
        <div className="flex min-w-0 items-center gap-4 px-6" data-testid="splash-org">
          {branding?.logoUrl ? (
            <img
              src={branding.logoUrl}
              alt=""
              className="block h-16 w-auto max-w-[240px] object-contain"
              referrerPolicy="no-referrer"
            />
          ) : (
            <span
              className="inline-flex size-16 shrink-0 items-center justify-center rounded-xl bg-[color:var(--org-accent,var(--color-primary))] text-2xl font-semibold text-[color:var(--org-accent-ink,#ffffff)]"
              aria-hidden="true"
            >
              {brandInitials(name)}
            </span>
          )}
          <span className="min-w-0 truncate text-[40px] font-semibold tracking-[-0.02em] text-grey-900">{name}</span>
        </div>
      ) : (
        <div className="flex items-center">
          <Mark className="size-20" />
          <span className="ml-3 font-logo text-[56px] font-semibold tracking-[-0.02em] text-grey-900">
            Semanti<b className="font-extrabold text-primary">CAD</b>
          </span>
        </div>
      )}
    </div>
  );
}
